module.exports = __webpack_public_path__ + "img/icon-total.8ea790f3.png";